<div class="product-review" *ngIf="categoryName && productReviews.length > 0 && (!isParent || subRegionName)">
  <div class="product-review_title">
    Top Reviews of {{ categoryName }} {{ subRegionName ? 'near you in ' + subRegionName : '' }}
  </div>
  <div class="reviews row">
    <ng-container *ngFor="let review of productReviews">
      <div class="col-md-4 mb-3">
        <div class="review-item">
          <div class="review-header">
            <div class="reviewer-info">
              <img src="assets/images/w.jpeg" alt="User Avatar" class="avatar">
              <div class="name-date">
                <div class="name">{{ review.appUser.profileCharacterName || 'Unknown' }}</div>
                <div class="date">{{ review.createdAt | date: 'MMM d, yyyy' }}</div>
              </div>
            </div>
            <div class="rating">
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
              <i class="fas fa-star"></i>
            </div>
          </div>
          <div class="review-body">
            <div class="review-content">
              {{ review.message }}
            </div>
            <div class="review-footer pb-3" *ngIf="review.memberShopProduct">
              <img [src]="imgUrl + review.memberShopProduct?.memberShopProductsImages[0]?.image"
                (error)="commonService.handleError($event)" alt="Product Image" class="product-image">
              <div class="d-flex flex-column">
                <div class="product-name">
                  {{ review.memberShopProduct?.name }}
                </div>
                <small class="company-name text-muted">
                  {{ review.memberShopProduct?.companyName }}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>